import * as React from "react";
import type { MachineDetail } from "@/features/lines/hooks";
import { formatRelativeTime } from "@/lib/display-labels";

// Extraído de pages/LineDetail.tsx (max-lines) — máquina offline há mais tempo, p/ AttentionStrip.
export function useFirstOfflineMachine(machines: MachineDetail[] | undefined) {
  const firstOfflineMachine = React.useMemo(() => {
    if (!machines || machines.length === 0) return null;
    const offline = machines
      .filter((m) => m.status === "NODATA" && m.statusSince !== null)
      .sort(
        (a, b) => new Date(a.statusSince ?? 0).getTime() - new Date(b.statusSince ?? 0).getTime()
      );
    return offline[0] ?? null;
  }, [machines]);

  const offlineFor = React.useMemo(
    () =>
      firstOfflineMachine?.statusSince ? formatRelativeTime(firstOfflineMachine.statusSince) : "",
    [firstOfflineMachine]
  );

  return { firstOfflineMachine, offlineFor };
}
